import { Injectable, Injector } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AthleteQuotesStore } from 'src/app/common-page-components/stores/entities-store/athlete-quotes.store';
import { DateFilterStore, RangeDateFilterStore, TextFilter } from '../../../common-page-components/stores/filters-store/filters-store';
import { HttpClient } from '@angular/common/http';
import { FiltersAthleteGeneralService } from '../../services/filters-athlete-general.service';

@Injectable({
  providedIn: 'root'
})
export class QuotesFiltersService {
  textFilter = new TextFilter('athlete-quotes-id');
  rangeDate = new RangeDateFilterStore(
    "range_date",
    new DateFilterStore(
      "from",
      "From",
      undefined,
      undefined,
      new BehaviorSubject({ value: undefined }),
      undefined, new Date(), 'date_from_quote'
    ),
    new DateFilterStore(
      "to",
      "To",
      undefined,
      undefined,
      new BehaviorSubject({ value: new Date() }),
      undefined, undefined, 'date_to_quote'
    )
  );
  filters = [
    // We don't have implementation for backend.
    //this.textFilter.filterInfo,
    this.rangeDate.filterInfo
  ];
  filter_athlete_service: FiltersAthleteGeneralService;

  constructor(protected http:HttpClient, protected injector:Injector) {
    this.rangeDate.filterInfo.options.date_to.max_date = new Date();
    this.filter_athlete_service = injector.get(FiltersAthleteGeneralService);
  }

  get quotesStore(){
    return this.filter_athlete_service.athleteQuotesStore;
  }
}
